module.exports = __webpack_public_path__ + "img/lector_de_codigo_fijo.263252a6.jpg";